module.exports = __webpack_public_path__ + "img/answer-big.055a522a.png";